import styled from 'styled-components';

export const SelectionContainer = styled.div``;
